import { render, staticRenderFns } from "./IncidentReportPoliceBox.vue?vue&type=template&id=d5066068&"
import script from "./IncidentReportPoliceBox.vue?vue&type=script&lang=js&"
export * from "./IncidentReportPoliceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports